import { first } from 'rxjs/operators';
import { Component } from '@angular/core';
import { BriefingService, UserService, TenantService } from '../services';
import { Router } from '@angular/router';
import * as _ from 'lodash';

@Component({
    styles: [`
        .sub-button {
            margin-right: 20px;
            margin-bottom: 8px;
        }

        .big-icon {
            font-size: 20px
        }

        .my-headers-align mat-expansion-panel-header {
            height: 175px !important;
        }

        .my-headers-align .mat-expansion-panel-header-title, 
        .my-headers-align .mat-expansion-panel-header-description {
            flex-basis: 0;
        }

        .briefingTitlePanel {
            max-width: 100%;
        }

        .title {
            margin-top: 0px;
            overflow-x: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .description {
            overflow-y: hidden;
            max-height: 55px;
            text-overflow: ellipsis;
        }
    `],
    template: `
        <mat-toolbar color="primary" id="picker-menu">
            <button mat-button *ngIf="showBack()" [routerLink]="['/']"><i class="big-icon fa fa-arrow-left"></i></button>
            <h2>Briefing Center</h2>
            <span fxFlex></span>
            <button *ngIf="!currentUser()" class="unauth-menu-button" mat-button (click)="login()">Login</button>
            <button *ngIf="!currentUser()" class="unauth-menu-button" mat-button [routerLink]="['/login']" [queryParams]="{start: 'register'}">Register</button>
            <button *ngIf="currentUser()" mat-button [routerLink]="['/settings']" matTooltip="Settings" matTooltipPosition="below"><mat-icon>settings</mat-icon></button>
        </mat-toolbar>
        <div>
            <mat-accordion fxFlex="80" fxFlexOffset="10" class="my-headers-align" >
                <mat-expansion-panel *ngFor="let briefing of briefings" (opened)="panels[briefing.id] = true">
                    <mat-expansion-panel-header [expandedHeight]="'175px'" [collapsedHeight]="'175px'">
                        <mat-panel-title fxFlex class="briefingTitlePanel">
                            <div fxFlex style="overflow-x: hidden;">
                                <h3 class="title">{{briefing.briefingTitle}}</h3>
                                <p>Schedule: {{scheduleDescription(briefing.schedule)}}</p>
                                <p class="description">{{briefing.description}}</p>
                            </div>
                        </mat-panel-title>
                        <button mat-icon-button [routerLink]="['/briefings', briefing.id, 'share']" style="padding-right: 18px; padding-top: 12px;">
                            <mat-icon aria-label="Share">share</mat-icon>
                        </button>
                        <button mat-fab *ngIf="isSubscribed(briefing.id)" matTooltip="Unsubscribe" (click)="toggleSubscription(briefing)" class="sub-button">
                            <mat-icon>done</mat-icon>
                        </button>
                        <button mat-fab *ngIf="!isSubscribed(briefing.id)" matTooltip="Subscribe" (click)="toggleSubscription(briefing)" color="primary" class="sub-button">
                            <mat-icon>add</mat-icon>
                        </button>
                    </mat-expansion-panel-header>
                    <briefing-preview [briefingId]="briefing.id" [visible]="panels[briefing.id]"></briefing-preview>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    `
})
export class BriefingListComponent {
    subscribedBriefings: any;
    tenant: any;
    briefings: any[] = [];
    panels =  {};
    
    constructor(private briefingService: BriefingService,
                private userService: UserService,
                tenantService: TenantService,
                private router: Router) {
        briefingService.getUnauthBriefings({ published: true, rows: 1000, noStreamBriefings: true }).pipe(first())
            .subscribe(briefingResponse => this.briefings = briefingResponse.content);
        tenantService.getUnauthTenantInfo().pipe(first())
        .subscribe(tenant => this.tenant = tenant);
        this.populateSubscriptions();
    }

    showBack = () => !(this.tenant && this.tenant.settings.clientDigestMenuOptions && this.tenant.settings.clientDigestMenuOptions.length === 0)

    populateSubscriptions = () => this.briefingService.getCurrentUserBriefings().pipe(first())
        .subscribe(briefingsResponse => this.subscribedBriefings = _.keyBy(briefingsResponse.content, 'id'));

    currentUser = () => this.userService.getCurrentUser();

    isSubscribed = briefingId => this.subscribedBriefings && this.subscribedBriefings[briefingId];

    scheduleDescription = (schedule) => this.briefingService.scheduleDescription(schedule);

    toggleSubscription = briefing => {
        const method = this.isSubscribed(briefing.id) ? 'unsubscribeFromBriefing' : 'subscribeToBriefing';

        return this.userService[method](this.userService.getCurrentUser(), briefing.id, briefing.streamId).pipe(first())
        .subscribe(() => {
            this.subscribedBriefings[briefing.id] = this.isSubscribed(briefing.id) ? undefined : briefing;
            this.populateSubscriptions();
        });
    };

    login() {
        this.router.navigate(['/login'], { queryParams: { 'originator': this.router.url }});
    };
}